import lwApi from 'operations/config/api';
import driverBffApi, {
  isDriverBffEnabled
} from 'operations/config/api/driver-bff';
import geolocation from '../geolocation';

/**
 * Performs a API request to getDriver
 *
 * @returns {Promise}
 */

export const driverInfoUrl = '/last-mile/v1/driver-info';
export const driverBffInfoUrl = '/v1/driver-info';

export default async function getDriver() {
  const { latitude, longitude } = await geolocation();
  const driverInfoParams =
    latitude && longitude ? `?lat=${latitude}&lng=${longitude}` : '';

  const viaBff = isDriverBffEnabled();
  const api = viaBff ? driverBffApi() : lwApi();
  const path = viaBff ? driverBffInfoUrl : driverInfoUrl;

  return api
    .url(`${path}${driverInfoParams}`)
    .get()
    .json();
}
